import { Component, OnInit } from '@angular/core';

import { UtilService } from './core/services/util.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'low-carbon-recommendation';
  tncUrl = environment.tncUrl;
  spinnerSrc: string = '';
  constructor(
    private util: UtilService
  ) {
    this.util.configureApplication();
  }

  ngOnInit() {
    this.spinnerSrc = `<img class='spinner-load mb-4' src="assets/images/common/Spinner.svg" alt='spinner'>`;
    this.util.configureApplication();
  }
}
